const chartData = [
  { subject: 'Algebra I', before: 61, after: 89 },
  { subject: 'Geometry', before: 63, after: 87 },
  { subject: 'Algebra 2', before: 58, after: 85 },
  { subject: 'Pre-Calc', before: 65, after: 91 },
  { subject: 'Grade 8', before: 66, after: 88 },
  { subject: 'Elementary', before: 68, after: 93 },
];

export default function ImprovementChart() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-emerald-50/30">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-3">Average Score Improvement by Subject</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto">
            Across all subjects, students consistently achieve dramatic score gains within weeks of starting the program.
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <div className="space-y-6">
            {chartData.map((row, i) => {
              const improvement = row.after - row.before;
              return (
                <div key={i} className="flex items-center gap-4">
                  <span className="text-sm font-semibold text-gray-600 w-24 shrink-0">{row.subject}</span>
                  <div className="flex-1 space-y-1.5">
                    <div className="flex items-center gap-2">
                      <div className="flex-1 h-3 bg-gray-100 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-rose-300 rounded-full"
                          style={{ width: `${row.before}%` }}
                        />
                      </div>
                      <span className="text-xs text-rose-400 font-semibold w-8 text-right">{row.before}</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="flex-1 h-3 bg-gray-100 rounded-full overflow-hidden">
                        <div
                          className="h-full bg-emerald-500 rounded-full"
                          style={{ width: `${row.after}%` }}
                        />
                      </div>
                      <span className="text-xs text-emerald-600 font-semibold w-8 text-right">{row.after}</span>
                    </div>
                  </div>
                  <div className="w-16 text-center">
                    <span className="inline-block bg-emerald-100 text-emerald-700 text-xs font-bold px-2.5 py-1 rounded-full">
                      +{improvement} pts
                    </span>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Legend */}
          <div className="flex items-center gap-6 mt-8 pt-6 border-t border-gray-100">
            <div className="flex items-center gap-2">
              <div className="w-4 h-3 bg-rose-300 rounded-full"></div>
              <span className="text-xs text-gray-500 font-medium">Before (avg. score)</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-4 h-3 bg-emerald-500 rounded-full"></div>
              <span className="text-xs text-gray-500 font-medium">After (avg. score)</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
